export const AUTH_ERROR_DB_SYNC = "db_sync";

/** Short-lived cookie: any JWT decode sees a new value and refetches authz from DB. */
export const WAAS_AUTHZ_BUMP_COOKIE = "waas-authz-bump";

/**
 * How long before re-fetching organizations/projects from DB into the JWT.
 * `stampLastSeenAt` piggybacks on this refresh, so this also bounds
 * `User.lastSeenAt` freshness for returning users.
 */
export const AUTHZ_JWT_TTL_MS = 5 * 60 * 1000;

/** Force a session authz refresh when the user returns after at least this idle period. */
export const AUTHZ_IDLE_REFRESH_MS = 30 * 60 * 1000;

/** `sessionStorage` key for last client activity (tab hidden / unload). */
export const WAAS_LAST_SESSION_ACTIVITY_KEY = "waas-last-session-activity-at";

/** Where an OAuth identity signed in; selects the audit summary written by `ensureUserFromOAuth`. */
export const OAUTH_SIGN_IN_SOURCE = {
  WAAS: "WAAS",
  PLATFORM: "PLATFORM",
} as const;

export const OAUTH_SIGN_IN_AUDIT_SUMMARY = {
  [OAUTH_SIGN_IN_SOURCE.WAAS]: {
    created: "Created user from OAuth sign-in",
    linked: "Linked external user id from OAuth sign-in",
  },
  [OAUTH_SIGN_IN_SOURCE.PLATFORM]: {
    created: "Created user from platform sign-in",
    linked: "Linked external user id from platform sign-in",
  },
} as const;

export const OAUTH_PROFILE_NAME_MAX_LENGTH = 255;

export const OAUTH_PROFILE_IMAGE_URL_MAX_LENGTH = 2048;
